module.exports = __webpack_public_path__ + "media/images/athletes/2117-e4d8e59c24938d5a39fb4a4e9bd1d6f0.png";